/**
 * 원 단위 금액을 사람이 읽는 꼴로.
 *
 * 0 과 빈 값은 모두 null 이다 -- 임대료를 안 적은 계약과 0원인 계약을 화면에서
 * 가를 이유가 없고, 부르는 쪽이 `money(x) && ...` 로 쓰기 좋다.
 */
export const money = (v) => (v ? `${Number(v).toLocaleString()}원` : null);
